"use strict";
exports.__esModule = true;
var category_tree_parser_1 = require("../logic/category-tree-parser");
var AssignCategoryConfig = /** @class */ (function () {
    function AssignCategoryConfig() {
    }
    return AssignCategoryConfig;
}());
angular.module('smartorg.r6.mgmts.assignCategory').directive('assignCategory', ['$timeout', function ($timeout) {
        return {
            restrict: 'E',
            template: require('../../template/assign-category.html'),
            scope: {
                smartorg: '=',
                tagsPropagateUp: '=?'
            },
            controller: function ($scope) {
                $scope.pagingOptions = {
                    pageSizes: [100, 200, 300],
                    pageSize: '100',
                    currentPage: 1
                };
                $scope.inProgress = false;
                $scope.gridOptions = {
                    enableColumnMenus: false,
                    enableColumnResizing: true,
                    // multiSelect: false,
                    enablePinning: true,
                    enableFiltering: true,
                    rowHeight: 20,
                    data: [],
                    // enablePaging: true,
                    // showFooter: true,
                    // totalServerItems: 'totalServerItems',
                    // pagingOptions: $scope.pagingOptions,
                    enableSorting: false,
                    // enableColumnResize: true,
                    columnDefs: []
                };
            },
            link: function (scope) {
                var hasChanges = false;
                scope.$on('manage:DisplayCategoryAssignment', function (event, args) {
                    hasChanges = args.hasChanges;
                    scope.treeID = args.treeId;
                    scope.categoryNameFromDefineCategory = args.categoryName;
                    scope.assignCategory(scope.treeID);
                });
                scope.$on('workbench:toggle-collapse:right', function () {
                    if (scope.$$phase) {
                        $(window).trigger('resize');
                    }
                });
                scope.$on('workbench:toggle-collapse:left', function () {
                    setTimeout(function () {
                        $(window).trigger('resize');
                    });
                });
                scope.debugFunc = function (input1, input2) {
                    console.log(input1, input2);
                };
                scope.assignCategory = function (treeID) {
                    scope.smartorg.getAssignCategory(treeID, 0).then(function (tree) {
                        scope.treeForAssignCategory = tree;
                        // Seems the second param is never used.
                        scope.setupData(tree, function (a1, a2, a3) {
                            console.log(a1, a2, a3);
                            alert("What have you done?");
                        }, scope.saveCategoryAssignment);
                    })["catch"](function (err) {
                        alert(err.message);
                    });
                };
                scope.saveCategoryAssignment = function (nodeTagList, cateLog) {
                    var nodeId = undefined;
                    scope.inProgress = true;
                    if (nodeTagList && nodeTagList.length > 0) {
                        nodeId = nodeTagList[0][0];
                    }
                    scope.gridOptions.data = formatGridData2(scope.nodes);
                    scope.smartorg.saveAssignCategoryTagsData(nodeId, nodeTagList, cateLog).then(function (msg) {
                        hasChanges = true;
                        scope.$emit('workbench:update_node_category', {
                            'nodeID': nodeId,
                            'nodeTagList': nodeTagList
                        });
                        scope.inProgress = false;
                        $timeout();
                    })["catch"](function (err) {
                        $timeout();
                        scope.inProgress = false;
                        console.error(err);
                        alert(err.message);
                    });
                };
                scope.goToDefineCategories = function () {
                    scope.$emit('displayDefineCategories');
                };
                scope.getCategoryIndex = function (name) {
                    if (!name) {
                        // Select 1st one by default.
                        return 0;
                    }
                    for (var i = 0; i < scope.categoryConfig.length; i++) {
                        if (scope.categoryConfig[i].CategoryName == name) {
                            return i;
                        }
                    }
                    return -1;
                };
                scope.setupData = function (assignCategoryConfig, saveDescendentTagsFn, saveCategoryNodesList) {
                    if (scope.data && !assignCategoryConfig) {
                        return;
                    }
                    scope.tree = assignCategoryConfig.tagData;
                    scope.saveDescendentTagsFn = saveDescendentTagsFn;
                    scope.index = assignCategoryConfig.index;
                    scope.categoryConfig = assignCategoryConfig.categoryConfig;
                    var index = scope.getCategoryIndex(scope.categoryNameFromDefineCategory);
                    if (index < 0) {
                        throw new Error("Category not found!");
                    }
                    scope.currentCategory = scope.categoryConfig[index];
                    scope.applyToPlatform = isApplyToPlatform();
                    scope.categoryName = scope.categoryConfig[index].CategoryName;
                    scope.categoryContents = scope.categoryConfig[index].CategoryEntries;
                    scope.currentPage = 1;
                    scope.treeParser = new category_tree_parser_1["default"](scope.tree, scope.categoryConfig, saveCategoryNodesList, scope.tagsPropagateUp);
                    scope.gridOptions.columnDefs = scope.treeParser.getColConfig(index);
                    scope.treeParser.changeCategory(index);
                    scope.nodes = scope.treeParser.currentNodes;
                    scope.currentIsMult = scope.treeParser.currentIsMult;
                    scope.AutoPropagateUp = scope.treeParser.AutoPropagateUp;
                    scope.filteredNodes = scope.treeParser.currentNodes;
                    scope.rootNode = scope.treeParser.rootNode;
                    scope.totalServerItems = scope.treeParser.nodes.length;
                    // scope.setPagingData(scope.nodes,
                    //     scope.pagingOptions.currentPage,
                    //     scope.pagingOptions.pageSize);
                    scope.gridOptions.data = formatGridData2(scope.nodes);
                    setTimeout(function () {
                        scope.$apply();
                    });
                };
                scope.selectCategoryName = function (categoryHeader, index) {
                    scope.currentCategory = scope.categoryConfig[index];
                    scope.applyToPlatform = isApplyToPlatform();
                    scope.categoryName = categoryHeader;
                    scope.gridOptions.columnDefs = scope.treeParser.getColConfig(index);
                    scope.treeParser.changeCategory(index);
                    scope.currentIsMult = scope.treeParser.currentIsMult;
                    scope.AutoPropagateUp = scope.treeParser.AutoPropagateUp;
                    scope.nodes = scope.treeParser.getCurrentNodes();
                    // scope.setPagingData(scope.nodes,
                    //     scope.pagingOptions.currentPage,
                    //     scope.pagingOptions.pageSize);
                    scope.gridOptions.data = formatGridData2(scope.nodes);
                    setTimeout(function () {
                        scope.$apply();
                    });
                };
                function formatGridData(nodeList) {
                    var colDefs = scope.gridOptions.columnDefs;
                    return nodeList.map(function (node) {
                        var rowData = angular.copy(node);
                        colDefs.forEach(function (colDef) {
                            var field = colDef.field;
                            if (node[field]) {
                                rowData[field] = node[field];
                            }
                            else {
                                rowData[field] = node.tags.split(',').indexOf(scope.categoryName + ':' + colDef.field) >= 0;
                            }
                        });
                        return rowData;
                    });
                }
                function formatGridData2(nodeList) {
                    var colDefs = scope.gridOptions.columnDefs;
                    var traversedParents = new Set();
                    // Map nodeList to formatted data
                    var formattedData = nodeList.map(function (node) {
                        var rowData = angular.copy(node);
                        colDefs.forEach(function (colDef) {
                            var field = colDef.field;
                            if (node[field]) {
                                rowData[field] = node[field];
                            }
                            else {
                                rowData[field] = node.tags.split(',').indexOf(scope.categoryName + ':' + colDef.field) >= 0;
                            }
                        });
                        return rowData;
                    });
                    // Update parent fields to false first
                    formattedData.forEach(function (node) {
                        if (!node.leaf) {
                            colDefs.forEach(function (colDef) {
                                var field = colDef.field;
                                if (field !== "name") {
                                    node[field] = false;
                                }
                            });
                        }
                    });
                    // Now update parent fields based on leaf nodes
                    formattedData.forEach(function (node) {
                        if (node.leaf) {
                            colDefs.forEach(function (colDef) {
                                var field = colDef.field;
                                // If leaf node's field is true
                                if (field !== "name" && node[field]) {
                                    updateParentFieldsRecursively(node, field, formattedData, traversedParents, scope.treeParser);
                                }
                            });
                        }
                    });
                    return formattedData;
                }
                function updateParentFieldsRecursively(node, field, formattedData, traversedParents, treeParser) {
                    var parentID = node.parentID;
                    var parentIndex = treeParser.idHash[parentID];
                    // Base case: Stop if there is no parentID or the parent has already been processed
                    if (!parentID || parentIndex === undefined) {
                        return;
                    }
                    var parentNode = formattedData[parentIndex];
                    // Update parent's field to true
                    if (parentNode) {
                        parentNode[field] = true;
                        // Mark parent as traversed
                        // traversedParents.add(parentID);
                        // Recurse with the parent node
                        updateParentFieldsRecursively(parentNode, field, formattedData, traversedParents, treeParser);
                    }
                }
                function isApplyToPlatform() {
                    return scope.currentCategory['AppliesTo'] === 'Platform';
                }
                scope.toggleLeafCat = function (entree, row, cell) {
                    // console.log(entree, row, cell);
                    var childrenIds = scope.treeParser.toggleLeafCat(row.entity.index, scope.categoryName, entree);
                    if (!scope.tagsPropagateUp) {
                        var parentID = row.entity.parentID;
                        var parentIndex = scope.treeParser.idHash[parentID];
                        var parentData = scope.gridOptions.data[parentIndex];
                        var hasTrue = false;
                        for (var i = 0; i < childrenIds.length; i++) {
                            var childIndex = scope.treeParser.idHash[childrenIds[i]];
                            var childData = scope.gridOptions.data[childIndex];
                            if (childData[entree]) {
                                hasTrue = true;
                                break;
                            }
                        }
                        parentData[entree] = hasTrue;
                    }
                };
                scope.setPagingData = function (data, page, pageSize) {
                    scope.currentPage = page;
                    scope.nodes = data.slice((page - 1) * pageSize, page * pageSize);
                    scope.totalServerItems = data.length;
                    // Will have apply in progress error if not wrapped.
                    setTimeout(function () {
                        if (!scope.$$phase) {
                            scope.$apply();
                        }
                    });
                };
                scope.isLeaf = function (nodeIndex) {
                    return scope.nodes[nodeIndex].leaf;
                };
                scope.$watch('pagingOptions', function (newVal, oldVal) {
                    if (oldVal !== undefined && newVal !== oldVal && newVal.currentPage !== oldVal.currentPage) {
                        scope.setPagingData(scope.treeParser.currentNodes, scope.pagingOptions.currentPage, scope.pagingOptions.pageSize);
                    }
                }, true);
                scope.toggleParentTag = function (entree, nodeIndex) {
                    scope.treeParser.toggleCheckNode(nodeIndex, scope.categoryName, entree);
                };
                scope.findTag = function (categoryEntree, index) {
                    return scope.treeParser.findCategory(index, scope.categoryName, categoryEntree);
                };
                scope.setTagDescendent = function (node, tag) {
                    var treeParser = scope.treeParser;
                    treeParser.toggleTag(node, tag);
                    console.log("Toggling " + tag + " for " + node.name + ", " + node.tags);
                    scope.saveDescendentTagsFn(treeParser.rootNode.id, node.id, node.tags);
                };
                var nodesFilter = function (search, nodes) {
                    var result = [];
                    var keyword = search.toLowerCase();
                    for (var i = 0; i < nodes.length; i++) {
                        if (nodes[i].name.toLowerCase().match(keyword) ||
                            nodes[i].path.toLowerCase().match(keyword)) {
                            result.push(nodes[i]);
                        }
                    }
                    return result;
                };
                scope.updateNodeSearch = function () {
                    scope.filteredNodes = nodesFilter(scope.nodeSearch, scope.treeParser.currentNodes);
                    scope.pagingOptions.currentPage = 1;
                    // scope.setPagingData(scope.filteredNodes,
                    //     scope.pagingOptions.currentPage,
                    //     scope.pagingOptions.pageSize);
                };
                scope.back = function () {
                    scope.$emit('workbench:back', { reload: hasChanges });
                };
            }
        };
    }]);
//# sourceMappingURL=assign-category-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/assign-category/app/js/plumbing/assign-category-directive.js